import { PaginationParams, SearchingProps } from 'modules/Shared/type';
import PlantUser from 'modules/PlantUser/model/PlantUser';

export interface PlantUserListState extends SearchingProps {
  plantUser: PlantUser[];
  fetching: boolean;
  totalPages: number;
  pagination: PaginationParams;
}

export const initPlantUserListState = (): PlantUserListState => ({
  plantUser: [],
  pagination: {
    page: 1,
    count: 100
  },
  totalPages: 1,
  filter: {},
  sort: {},
  fetching: false
});
